module.exports = __webpack_public_path__ + "media/images/soar/site/bg_comments-82252b835b450e92107ac99cafa487ba.svg";